import React, { Fragment, useEffect, useState } from "react"
import PropTypes from "prop-types"
import {
  Row,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  Col,
  Label,
} from "reactstrap"
import { withRouter } from "react-router"
//i18n
import { withTranslation } from "react-i18next"
import API from "../../apis"
//Import Date Picker
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import Select from "react-select"
import APIS from "../../apis"
import getDay from "date-fns/getDay"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Slide } from "react-toastify"
import ISGGB from "../../assets/images/flshs.png"
import tunisie_rep from "../../assets/images/tn_rep.png"
const AddTest = props => {
  var userAuthEnseignant = JSON.parse(localStorage.getItem("userAuthEnseignant"))
  var enseignant_id = userAuthEnseignant.user.enseignant_id
  var annee = userAuthEnseignant.user.annee_id
  const [loading, setLoading] = useState(false)
  const [quarts, setQuarts] = useState([])
  const [jours, setJours] = useState([])
  const [loadingAdd, setLoadingAdd] = useState(true)
  const [modal, setModal] = useState(false)
  const [jourId, setJourId] = useState("")
  const [date, setDate] = useState(null)
  const [typeExamen, setTypeExamen] = useState([])
  const [selectTypeExamen, setSelectTypeExamen] = useState("")
  const [seanceId, setSeanceId] = useState("")
  const [minDate, setMinDate] = useState(new Date())
  const [maxDate, setMaxDate] = useState(new Date())
  const [etat, setEtat] = useState("")
  const [disable, setDisable] = useState(false)
  const [anneeD, setAnneeD] = useState("")
  const [name, setName] = useState("")
  const [modaliteEvaluation, setModaliteEvaluation] = useState("")
  useEffect(async () => {
    if (props.type === "1") {
      setName("Test")
    } else {
      setName("DS")
    }
    if (props.type == 2 || props.type == 3) {
      const resT = await APIS.get("type_examen/select_ds").then(resT => {
        setTypeExamen(resT.data.Type_examen)
      })
    } else {
      const resT = await APIS.get("type_examen/select_test").then(resT => {
        setTypeExamen(resT.data.Type_examen)
      })
    }
    const fetchAnnee = async () => {
      const resD = await API.post("annee/get_by_id", { id: annee })
      setAnneeD(resD.data.Annee.annee_scolaire)
    }
    fetchAnnee()
    const resE = await API.post("emploi/get_by_id", {
      enseignant_id: enseignant_id,
      semestre_id: props.semestre_value,
      annee_id: annee,
    }).then(resE => {
      setQuarts(resE.data.emploi[0].quarts)
      setJours(resE.data.emploi[0].jours)
      setLoading(true)
    })
    API.post("ds_parametrage/getBy_annee_semestre", {
      semestre_id: props.semestre_value,
      annee_id: annee,
    }).then(resAnnee => {
      setMinDate(new Date(resAnnee.data.params.date_debut))
      setMaxDate(new Date(resAnnee.data.params.date_fin))
      setEtat(resAnnee.data.params.etat)
    })
  }, [props.semestre_value])

  // const isDateValid = date => {
  //     const day = getDay(date) // Jour de la semaine
  //     const withinRange = date >= minDate && date <= maxDate // Dans l'intervalle
  //     return day === jourId && withinRange // Les deux conditions doivent être vraies
  // }
  const isDateValid = (date) => {
    if (!minDate || !maxDate) return true;

    const day = getDay(date);        // Jour sélectionné
    const time = date.setHours(0,0,0,0);
    const min = minDate.setHours(0,0,0,0);
    const max = maxDate.setHours(0,0,0,0);

    const withinRange = time >= min && time <= max;

    return day === jourId && withinRange;
  };
  const getDayClass = (d) => {
    if (!minDate || !maxDate) return "";

    const day = d.setHours(0,0,0,0);
    const min = minDate.setHours(0,0,0,0);
    const max = maxDate.setHours(0,0,0,0);

    // Couleur seulement si valide + bon jour
    if (day >= min && day <= max && getDay(d) === jourId) {
      return "day-in-range";
    }

    return "";
  };

  const isWeekday = date => {
    const day = getDay(date)
    return day === jourId
  }

  const toggle = (element, elem,modalite_evaluation) => {
    setModal(!modal)
    setLoadingAdd(true)
    setDate(null)
    setSelectTypeExamen("")
    var jour_id = elem
    var seance_id = element.id_seance
    setJourId(jour_id)
    setSeanceId(seance_id)
    setModaliteEvaluation(modalite_evaluation)
  }

  const save = async () => {
    if (date == null) {
      toast.error("⛔ Date obligatoire !", {
        containerId: "A",
      })
    }
    else if (selectTypeExamen !== "") {
      setLoadingAdd(false)
      // convert date début
      let dateExamen = date
      let month = "" + (dateExamen.getMonth() + 1)
      let day = "" + dateExamen.getDate()
      let year = dateExamen.getFullYear()
      if (month.length < 2) month = "0" + month
      if (day.length < 2) day = "0" + day
      let convertDate = [year, month, day].join("-")
      //
      const res = await APIS.post("avis/examen/adds", {
        date: convertDate,
        type_examen_id: selectTypeExamen.value,
        seance_id: seanceId,
        annee_id: annee,
        semestre_id:props.semestre_value,
      })
        .then(res => {
          setModal(false)
          if (res.data.errNum === "400" || res.data.errNum === 400) {
            toast.error("⛔ " + res.data.msg, {
              containerId: "A",
            })
          }
        })
        .catch(() => {
          toast.error("Problème lors de l'insertion !", {
            containerId: "A",
          })
        })
    } else {
      toast.error("⛔ Type examen obligatoire !", {
        containerId: "A",
      })
    }
  }

  return (
    <React.Fragment>
      <style>{`
        /* Toutes les dates entre minDate et maxDate */
        .day-in-range {
          background-color: #ffdddd !important;
          color: red !important;
          border-radius: 50% !important;
          font-weight: bold;
        }
      `}</style>
      {loading ? (
        <Row>
          <div className="container">
            <div className="row" style={{ paddingTop: "30px" }}>
              <div
                className="col"
                style={{ fontSize: "12px", textAlign: "center" }}
              >
                République Tunisienne
                <div
                  className="col"
                  style={{
                    fontSize: "12px",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  {"Ministère de l'enseignement supérieur,"}
                </div>
                <div
                  className="col"
                  style={{ fontSize: "12px", textAlign: "center" }}
                >
                  {" "}
                  de la Recherche Scientifique
                </div>
                <div
                  className="col"
                  style={{
                    marginLeft: 0,
                    fontSize: "12px",
                    textAlign: "center",
                    fontWeight: "bold",
                    paddingTop: "10px",
                  }}
                >
                  Université de Sfax
                </div>
                <div
                  className="col"
                  style={{
                    marginLeft: 0,
                    fontSize: "12px",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  {"Faculté des Lettres et des Sciences Humaines de Sfax"}
                </div>
              </div>
              <div
                className="col"
                style={{ position: "relative", textAlign: "center" }}
              >
                <img style={{ width: "45%" }} src={ISGGB} />
              </div>
              <div
                className="col"
                style={{ position: "relative", textAlign: "center" }}
              >
                <img style={{ width: "28%" }} src={tunisie_rep} />
              </div>
              <div
                className="col"
                style={{ fontSize: "12px", textAlign: "center" }}
              >
                الجمهورية التونسية
                <div
                  className="col"
                  style={{ fontSize: "12px", textAlign: "center" }}
                >
                  وزارة التعليم العالي والبحث العلمي
                </div>
                <div
                  className="col"
                  style={{
                    fontSize: "12px",
                    textAlign: "center",
                    fontWeight: "bold",
                    paddingTop: "10px",
                  }}
                >
                  جامعة صفافس
                </div>
                <div
                  className="col"
                  style={{
                    textAlign: "center",
                    marginRight: 0,
                    fontSize: "12px",
                    fontWeight: "bold",
                  }}
                >
                  كلية الآداب و العلوم الانسانية بصفاقس{" "}
                </div>
              </div>
            </div>
            <hr
              style={{
                width: "100%",
                marginTop: "0.1%",
                color: "black",
              }}
            />
            <div className="row">
              <div
                className="col-md-4"
                style={{
                  display: "flex",
                  fontSize: "13px",
                  justifyContent: "start",
                }}
              ></div>
              <div
                className="col-md-4"
                style={{
                  display: "flex",
                  fontSize: "15px",
                  justifyContent: "center",
                }}
              ></div>
              <div className="col-md-4">
                <div
                  style={{
                    display: "flex",
                    fontSize: "13px",
                    justifyContent: "end",
                  }}
                >
                  <span style={{ paddingRight: "4px" }}>
                    Année Universitaire:{" "}
                  </span>
                  <span style={{ fontWeight: "bold" }}>{anneeD}</span>
                </div>
                <div
                  style={{
                    display: "flex",
                    fontSize: "13px",
                    justifyContent: "end",
                  }}
                >
                  <span style={{ paddingRight: "4px" }}>Semestre:</span>
                  <span style={{ fontWeight: "bold" }}>
                    {props.semestre_label}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="table-responsive mt-4">
              <table className="table table-bordered text-center">
                <thead className="table table-light">
                  <tr>
                    <th></th>
                    {quarts.map(el => (
                      <th key={el.id_quart} style={{ whiteSpace: "nowrap" }}>
                        {el.label_quart}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {jours.map((elem, index) => (
                    <tr key={index}>
                      <td style={{ fontWeight: "bold" }}>{elem.label_jour}</td>
                      {elem.seances.map((element, indice) => (
                        <td
                          key={indice}
                          style={{ padding: "0px" }}
                          className="td-emploi"
                        >
                          {element.options.map((elle, ind) => (
                            <div
                              key={ind}
                              style={{
                                padding: "5px 5px 5px 5px",
                                cursor: "pointer",
                              }}
                              onClick={() => toggle(elle, elem.id_jour,elle.modalite_evaluation)}
                            >

                              <p
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                {elle.label_matiere}
                              </p>
                              <p
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                {elle.label_group}
                              </p>
                              <p
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                {elle.label_salle}
                              </p>
                              <br/>
                              <p>
                                {elle.type == 1 ? (
                                  <div className="div-icon">
                                    <span className="icon-cour">C</span>
                                    {element.quan === 1 ? (
                                      <div className="icon_quan"></div>
                                    ) : null}
                                  </div>
                                ) : elle.type == 2 ? (
                                  <div className="div-icon">
                                    <span className="icon-td">TD</span>
                                    {element.quan === 1 ? (
                                      <div className="icon_quan"></div>
                                    ) : null}
                                  </div>
                                ) : elle.type == 3 ? (
                                  <div className="div-icon">
                                    <span className="icon-tp">TP</span>
                                    {element.quan === 1 ? (
                                      <div className="icon_quan"></div>
                                    ) : null}
                                  </div>
                                ) : elle.type == 4 ? (
                                  <div className="div-icon">
                                    <span className="icon-autre">A</span>
                                    {element.quan === 1 ? (
                                      <div className="icon_quan"></div>
                                    ) : null}
                                  </div>
                                ) : null}
                              </p>

                            </div>
                          ))}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Row>
      ) : (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Spinner type="grow" className="ms-6" color="primary" />
          </div>
          <h4 style={{ textAlign: "center", marginTop: "2%" }} className="ms-6">
            Chargement ...
          </h4>
        </div>
      )}
      <Modal
        style={{
          maxWidth: "700px",
          width: "100%",
        }}
        isOpen={modal}
        toggle={toggle}
        centered={true}
      >
        <ModalHeader
          style={{
            width: "100% !important",
            textAlign: "center !important",
          }}
          toggle={toggle}
          tag="h4"
        >
          Ajouter {name}
        </ModalHeader>
        <ModalBody>
          {loadingAdd ? (
            <Fragment>
              <Row>
                <Col lg="6">
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">Type examen</Label>
                    <Select
                      options={typeExamen}
                      isSearchable={true}
                      value={selectTypeExamen}
                      onChange={e => setSelectTypeExamen(e)}
                    />
                  </div>
                </Col>
                <Col lg="6">
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">
                      {props.t("Date")}
                      <span style={{ color: "red", paddingLeft: "5px" }}>
                        *
                      </span>
                    </Label>
                    {props.type == 3 && modaliteEvaluation == "Contrôle continu" ? (
                      // <DatePicker
                      //   selected={date}
                      //   onChange={e => setDate(e)}
                      //   filterDate={isDateValid}
                      //   dateFormat="dd/MM/yyyy"
                      //   className="form-control ddate"
                      //   minDate={minDate}
                      //   maxDate={maxDate}
                      // />
                      <DatePicker
                        selected={date}
                        onChange={(e) => setDate(e)}
                        dateFormat="dd/MM/yyyy"
                        className="form-control ddate"
                        filterDate={isDateValid}
                        dayClassName={getDayClass}
                      />

                    ):(
                      <DatePicker
                        selected={date}
                        onChange={e => setDate(e)}
                        filterDate={isWeekday}
                        dateFormat="dd/MM/yyyy"
                        className="form-control ddate"
                      />
                    )}
                  </div>
                </Col>
              </Row>
              <Row>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  {" "}
                  <Col lg="6">
                    <div className="text-center mt-4">
                      <button
                        type="button"
                        className="btn btn-primary "
                        onClick={save}
                      >
                        CONFIRMER
                      </button>
                    </div>
                  </Col>
                </div>
              </Row>
            </Fragment>
          ) : (
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {" "}
                <Spinner type="grow" className="ms-6" color="primary" />
              </div>
              <h4
                style={{ textAlign: "center", marginTop: "2%" }}
                className="ms-6"
              >
                {" "}
                {"Chargement"} ...{" "}
              </h4>
            </div>
          )}
        </ModalBody>
      </Modal>
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
    </React.Fragment>
  )
}

export default withRouter(withTranslation()(AddTest))
AddTest.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
  semestre_value: PropTypes.object,
  type: PropTypes.any,
  semestre_label: PropTypes.object,
}
